import styled from "styled-components";

export const NavBar = styled.nav`
    font-size: 1.25rem;

    display: flex;
    justify-content: space-between;
    align-items: center;

    padding-left: 0.75rem;
    padding-right: 0.75rem;

    box-sizing: border-box;

    a {
        display: flex;
        justify-content: start;
        align-items: center;
    }
`;
